module.exports = __webpack_public_path__ + "static/img/7-2.c84f826.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/7-2.png
// module id = /+Vx
// module chunks = 0